@if (is_loading()) {
  <div class="dialog-loading">
    <mat-spinner diameter="40"></mat-spinner>
  </div>
} @else if (error_message()) {
  <div class="dialog-error">
    <p>{{ error_message() }}</p>
    <button mat-button type="button" (click)="close()">Cerrar</button>
  </div>
} @else if (normalized_data()) {
  <app-kpi-evaluation-card [kpiData]="normalized_data()!" />
}
